module.exports = __webpack_public_path__ + "static/media/logo.c3420c8f.png";